const { Modal } = window.od;

export function showProgressModal() {
	const modalId = document.querySelector('#progressModal');
	if (modalId) {
		const modal = new Modal(modalId);
		modal.show();
	}
}
